@if (gridConfig) {
    <div class="claim-rules-grid">
        <inavista-grid #businessRulesGrid
            [config]="gridConfig"
            (exportRequested)="onExportRequested()" />
    </div>
}
